import { all, call, fork, takeEvery } from "redux-saga/effects";
import requestFunction from "../../Utils/sagaGenericFunction";
import {
  getSignupSuccess,
  getSignupFailure,
  getEnterOtpSuccess,
  getEnterOtpFailure,
  getResendOtpSuccess,
  getResendOtpFailure,
  getSigninSuccess,
  getSigninFailure,
  getUserTypeSuccess,
  getUserTypeFailure,
  getStateSuccess,
  getStateFailure,
  getLocalGovernmentByStateIdSuccess,
  getLocalGovernmentByStateIdFailure,
  postUserTypeDataSuccess,
  postUserTypeDataFailure,
  postBusinessDetailsSuccess,
  postBusinessDetailsFailure,
  postBusinessLocationSuccess,
  postBusinessLocationFailure,
  postBusinessHistorySuccess,
  postBusinessHistoryFailure,
  postBusinessContactSuccess,
  postBusinessContactFailure,
  postUserDetailsSuccess,
  postUserDetailsFailure,
  getRelationshipTypeSuccess,
  getRelationshipTypeFailure,
  getForgotPasswordSuccess,
  getForgotPasswordFailure,
  getNewPasswordSuccess,
  getNewPasswordFailure,
  getChangePasswordSuccess,
  getChangePasswordFailure,
  getAllCustomerSuccess,
  getAllCustomerFailure,
  getAllSystemAdminSuccess,
  getAllSystemAdminFailure,
  getAllIndependentDistributorshipSuccess,
  getAllIndependentDistributorshipFailure,
  getIndependentDistributorNearMeSuccess,
  getIndependentDistributorNearMeFailure,
  getNatureOfBusinessSuccess,
  getNatureOfBusinessFailure,
  postBusinessDocumentSuccess,
  postBusinessDocumentFailure,
  getBusinessDocumentSuccess,
  getBusinessDocumentFailure,
  getUserByIdSuccess,
  getUserByIdFailure,
  getPendingApplicationSuccess,
  getPendingApplicationFailure,
  getApprovedApplicationSuccess,
  getApprovedApplicationFailure,
  postAssignedDistributorSuccess,
  postAssignedDistributorFailure,
  getUserProfileDetailsSuccess,
  getUserProfileDetailsFailure,
  postBusinessAreaSuccess,
  postBusinessAreaFailure,
  getBusinessAreaSuccess,
  getBusinessAreaFailure,
  postProfilePictureAvatarSuccess,
  postProfilePictureAvatarFailure,
  getAllRolesSuccess,
  getAllRolesFailure,
  postCreateEmployeeSuccess,
  postCreateEmployeeFailure,
  postCreateDistributorCustomerSuccess,
  postCreateDistributorCustomerFailure,
  postCreateRetailerCustomerSuccess,
  postCreateRetailerCustomerFailure,
  postCreateExclusiveCustomerSuccess,
  postCreateExclusiveCustomerFailure,
  updateEmployeeDetailsSuccess,
  updateEmployeeDetailsFailure,
  getEmployeeUnpaginatedDataSuccess,
  getEmployeeUnpaginatedDataFailure,
  updateRoleDetailsSuccess,
  updateRoleDetailsFailure,
  updateBusinessDocumentSuccess,
  updateBusinessDocumentFailure,
  updateBusinessAreaSuccess,
  updateBusinessAreaFailure,
  getGooglePlacesSuccess,
  getGooglePlacesFailure,
  googleSignInSuccess,
  googleSignInFailure,
  googleSignUpSuccess,
  googleSignUpFailure,
  updateUserStatusSuccess,
  updateUserStatusFailure,
  updateUserDataSuccess,
  updateUserDataFailure,
  updateBusinessDataSuccess,
  updateBusinessDataFailure,
  deleteUserAccountSuccess,
  deleteUserAccountFailure,
  getRejectedApplicationSuccess,
  getRejectedApplicationFailure,
  rejectApplicationSuccess,
  rejectApplicationFailure,
  searchCustomersSuccess,
  searchCustomersFailure,
  searchRolesSuccess,
  searchRolesFailure,
  deleteApplicantDocumentSuccess,
  deleteApplicantDocumentFailure,
  fetchTempOtpForAdminSuccess,
  fetchTempOtpForAdminFailure,
  // 👉 NEW 2FA IMPORTS
  setup2FASuccess,
  setup2FAFailure,
  verifySetup2FASuccess,
  verifySetup2FAFailure,
  disable2FASuccess,
  disable2FAFailure,
  verify2FALoginSuccess,
  verify2FALoginFailure,
} from "../Actions";
import {
  CHANGE_PASSWORD,
  CREATE_DISTRIBUTOR_CUSTOMER,
  CREATE_EMPLOYEE,
  CREATE_EXCLUSIVE_CUSTOMER,
  CREATE_RETAILER_CUSTOMER,
  ENTER_OTP,
  FORGOT_PASSWORD,
  GET_ALL_CUSTOMERS,
  GET_ALL_INDEPENDENT_DISTRIBUTORSHIP,
  GET_ALL_ROLES,
  GET_ALL_SYSTEM_ADMIN,
  GET_APPROVED_APPLICATION,
  GET_BUSINESS_AREA,
  GET_BUSINESS_DOCUMENT,
  GET_INDEPENDENT_DISTRIBUTOR_NEAR_ME,
  GET_LOCAL_GOVERNMENT_BY_STATE_ID,
  GET_NATURE_OF_BUSINESS,
  GET_PENDING_APPLICATION,
  GET_RELATIONSHIP_TYPE,
  GET_STATE,
  GET_EMPLOYEE_DATA,
  GET_USER_BY_ID,
  GET_USER_PROFILE_DETAILS,
  GET_USER_TYPE,
  NEW_PASSWORD,
  POST_ASSIGNED_DISTRIBUTOR,
  POST_BUSINESS_AREA,
  POST_BUSINESS_CONTACT,
  POST_BUSINESS_DETAILS,
  POST_BUSINESS_DOCUMENT,
  POST_BUSINESS_HISTORY,
  POST_BUSINESS_LOCATION,
  POST_PROFILE_PICTURE_AVATAR,
  POST_USER_DETAILS,
  POST_USER_TYPE,
  RESEND_OTP,
  SIGN_IN,
  SIGN_UP,
  UPDATE_EMPLOYEE_DETAILS,
  UPDATE_ROLE,
  UPDATE_BUSINESS_DOCUMENT,
  UPDATE_BUSINESS_AREA,
  GET_GOOGLE_PLACES,
  GOOGLE_SIGN_IN,
  GOOGLE_SIGN_UP,
  UPDATE_USER_STATUS,
  UPDATE_USER_DATA,
  UPDATE_BUSINESS_DATA,
  DELETE_USER_ACCOUNT,
  GET_REJECTED_APPLICATION,
  REJECT_APPLICATION,
  SEARCH_CUSTOMERS,
  SEARCH_ROLES,
  DELETE_APPLICANT_DOCUMENT,
  FETCH_TEMP_OTP_FOR_ADMIN,
  // 👉 NEW 2FA IMPORTS
  SETUP_2FA,
  VERIFY_SETUP_2FA,
  DISABLE_2FA,
  VERIFY_2FA_LOGIN,
} from "../ActionTypes";
import {
  GetAllCustomerApi,
  GetAllIndependentDistributorshipApi,
  GetAllRolesApi,
  GetAllSystemAdminApi,
  GetApprovedApplicationApi,
  GetBusinessAreaApi,
  GetBusinessDocumentApi,
  GetChangePasswordApi,
  GetForgotPasswordApi,
  GetIndependentDistributorNearMeApi,
  GetLocalGovernmentByStateIdApi,
  GetNatureOfBusinessApi,
  GetNewPasswordApi,
  GetOtpVerificationApi,
  GetPendingApplicationApi,
  GetRelationshipTypeApi,
  GetResendOtpApi,
  GetSiginApi,
  GetSignUpApi,
  GetStateApi,
  GetUserByIdApi,
  GetUserProfileDetailsApi,
  GetUserTypeApi,
  GetEmployeeDataUnpaginatedApi,
  PostAssignedDistributorApi,
  PostBusinessAreapi,
  PostBusinessContactApi,
  PostBusinessDetailsApi,
  PostBusinessDocumentApi,
  PostBusinessHistoryApi,
  PostBusinessLocationApi,
  PostCreateDistributorApi,
  PostCreateEmployeeApi,
  PostCreateExclusiveApi,
  PostCreateRetailerApi,
  PostUserOnboardingDetailsApi,
  PostUserTypeApi,
  UpdateEmployeeDetailsApi,
  UpdateProfilePictureApi,
  UpdateRoleDetailsApi,
  UpdateBusinessDocumentApi,
  UpdateBusinessAreapi,
  GetGooglePlacesApi,
  GoogleSignInApi,
  UpdateUserStatusApi,
  UpdateUserDataApi,
  UpdateBusinessDataApi,
  DeleteUserAccountApi,
  GetRejectedApplicationApi,
  RejectApplicationApi,
  SearchCustomersApi,
  SearchRolesApi,
  DeleteApplicantDocumentApi,
  getTempOtpForAdminApi,
  // 👉 NEW 2FA IMPORTS
  Setup2FAApi,
  VerifySetup2FAApi,
  Disable2FAApi,
  Verify2FALoginApi,
} from "../Api";

// =================Auth sagas================
const getSignupWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    getSignupSuccess,
    getSignupFailure,
    GetSignUpApi,
    payload,
  );
};
export const getSignupWatcher = function* () {
  yield takeEvery(SIGN_UP, getSignupWorker);
};

const getOtpVerificationWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    getEnterOtpSuccess,
    getEnterOtpFailure,
    GetOtpVerificationApi,
    payload,
  );
};
export const getOtpVerificationWatcher = function* () {
  yield takeEvery(ENTER_OTP, getOtpVerificationWorker);
};

const getResendOtpVerificationWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    getResendOtpSuccess,
    getResendOtpFailure,
    GetResendOtpApi,
    payload,
  );
};
export const getResendOtpVerificationWatcher = function* () {
  yield takeEvery(RESEND_OTP, getResendOtpVerificationWorker);
};

const getSigninWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    getSigninSuccess,
    getSigninFailure,
    GetSiginApi,
    payload,
  );
};
export const getSigninWatcher = function* () {
  yield takeEvery(SIGN_IN, getSigninWorker);
};

const getForgotPasswordWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    getForgotPasswordSuccess,
    getForgotPasswordFailure,
    GetForgotPasswordApi,
    payload,
  );
};
export const getForgotPasswordWatcher = function* () {
  yield takeEvery(FORGOT_PASSWORD, getForgotPasswordWorker);
};

const getNewPasswordWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    getNewPasswordSuccess,
    getNewPasswordFailure,
    GetNewPasswordApi,
    payload,
  );
};
export const getNewPasswordWatcher = function* () {
  yield takeEvery(NEW_PASSWORD, getNewPasswordWorker);
};

const getChangePasswordWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    getChangePasswordSuccess,
    getChangePasswordFailure,
    GetChangePasswordApi,
    payload,
  );
};
export const getChangePasswordWatcher = function* () {
  yield takeEvery(CHANGE_PASSWORD, getChangePasswordWorker);
};

const getUserTypeWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    getUserTypeSuccess,
    getUserTypeFailure,
    GetUserTypeApi,
    payload,
  );
};
export const getUserTypeWatcher = function* () {
  yield takeEvery(GET_USER_TYPE, getUserTypeWorker);
};

const getRelationshipTypeWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    getRelationshipTypeSuccess,
    getRelationshipTypeFailure,
    GetRelationshipTypeApi,
    payload,
  );
};
export const getRelationshipTypeWatcher = function* () {
  yield takeEvery(GET_RELATIONSHIP_TYPE, getRelationshipTypeWorker);
};

const getNatureOfBusinessWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    getNatureOfBusinessSuccess,
    getNatureOfBusinessFailure,
    GetNatureOfBusinessApi,
    payload,
  );
};
export const getNatureOfBusinessWatcher = function* () {
  yield takeEvery(GET_NATURE_OF_BUSINESS, getNatureOfBusinessWorker);
};

const getStateWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    getStateSuccess,
    getStateFailure,
    GetStateApi,
    payload,
  );
};
export const getStateWatcher = function* () {
  yield takeEvery(GET_STATE, getStateWorker);
};

const getLocalGovermentByStateIdWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    getLocalGovernmentByStateIdSuccess,
    getLocalGovernmentByStateIdFailure,
    GetLocalGovernmentByStateIdApi,
    payload,
  );
};
export const getLocalGovermentByStateIdWatcher = function* () {
  yield takeEvery(
    GET_LOCAL_GOVERNMENT_BY_STATE_ID,
    getLocalGovermentByStateIdWorker,
  );
};

const postUserTypeWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    postUserTypeDataSuccess,
    postUserTypeDataFailure,
    PostUserTypeApi,
    payload,
  );
};
export const postUserTypeWatcher = function* () {
  yield takeEvery(POST_USER_TYPE, postUserTypeWorker);
};

const postBusinessDetailsWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    postBusinessDetailsSuccess,
    postBusinessDetailsFailure,
    PostBusinessDetailsApi,
    payload,
  );
};
export const postBusinessDetailsWatcher = function* () {
  yield takeEvery(POST_BUSINESS_DETAILS, postBusinessDetailsWorker);
};

const postBusinessLocationWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    postBusinessLocationSuccess,
    postBusinessLocationFailure,
    PostBusinessLocationApi,
    payload,
  );
};
export const postBusinessLocationWatcher = function* () {
  yield takeEvery(POST_BUSINESS_LOCATION, postBusinessLocationWorker);
};

const postBusinessHistoryWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    postBusinessHistorySuccess,
    postBusinessHistoryFailure,
    PostBusinessHistoryApi,
    payload,
  );
};
export const postBusinessHistoryWatcher = function* () {
  yield takeEvery(POST_BUSINESS_HISTORY, postBusinessHistoryWorker);
};

const postBusinessContactWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    postBusinessContactSuccess,
    postBusinessContactFailure,
    PostBusinessContactApi,
    payload,
  );
};
export const postBusinessContactWatcher = function* () {
  yield takeEvery(POST_BUSINESS_CONTACT, postBusinessContactWorker);
};

const postUserDetailsWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    postUserDetailsSuccess,
    postUserDetailsFailure,
    PostUserOnboardingDetailsApi,
    payload,
  );
};
export const postUserDetailsWatcher = function* () {
  yield takeEvery(POST_USER_DETAILS, postUserDetailsWorker);
};

const postBusinessDocumentWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    postBusinessDocumentSuccess,
    postBusinessDocumentFailure,
    PostBusinessDocumentApi,
    payload,
  );
};
export const postBusinessDocumentWatcher = function* () {
  yield takeEvery(POST_BUSINESS_DOCUMENT, postBusinessDocumentWorker);
};

const updateBusinessDocumentWorker = function* ({ body, payload }) {
  yield call(
    requestFunction,
    updateBusinessDocumentSuccess,
    updateBusinessDocumentFailure,
    UpdateBusinessDocumentApi,
    body,
    payload,
  );
};
export const updateBusinessDocumentWatcher = function* () {
  yield takeEvery(UPDATE_BUSINESS_DOCUMENT, updateBusinessDocumentWorker);
};

const getBusinessDocumentWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    getBusinessDocumentSuccess,
    getBusinessDocumentFailure,
    GetBusinessDocumentApi,
    payload,
  );
};
export const getBusinessDocumentWatcher = function* () {
  yield takeEvery(GET_BUSINESS_DOCUMENT, getBusinessDocumentWorker);
};

const postBusinessAreaWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    postBusinessAreaSuccess,
    postBusinessAreaFailure,
    PostBusinessAreapi,
    payload,
  );
};
export const postBusinessAreaWatcher = function* () {
  yield takeEvery(POST_BUSINESS_AREA, postBusinessAreaWorker);
};

const updateBusinessAreaWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    updateBusinessAreaSuccess,
    updateBusinessAreaFailure,
    UpdateBusinessAreapi,
    payload,
  );
};
export const updateBusinessAreaWatcher = function* () {
  yield takeEvery(UPDATE_BUSINESS_AREA, updateBusinessAreaWorker);
};

const getBusinessAreaWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    getBusinessAreaSuccess,
    getBusinessAreaFailure,
    GetBusinessAreaApi,
    payload,
  );
};
export const getBusinessAreaWatcher = function* () {
  yield takeEvery(GET_BUSINESS_AREA, getBusinessAreaWorker);
};

const getAllCustomerWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    getAllCustomerSuccess,
    getAllCustomerFailure,
    GetAllCustomerApi,
    payload,
  );
};
export const getAllCustomerWatcher = function* () {
  yield takeEvery(GET_ALL_CUSTOMERS, getAllCustomerWorker);
};

const getAllSystemAdminWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    getAllSystemAdminSuccess,
    getAllSystemAdminFailure,
    GetAllSystemAdminApi,
    payload,
  );
};
export const getAllSystemAdminWatcher = function* () {
  yield takeEvery(GET_ALL_SYSTEM_ADMIN, getAllSystemAdminWorker);
};

const getAllIndependentDistributorshipWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    getAllIndependentDistributorshipSuccess,
    getAllIndependentDistributorshipFailure,
    GetAllIndependentDistributorshipApi,
    payload,
  );
};
export const getAllIndependentDistributorshipWatcher = function* () {
  yield takeEvery(
    GET_ALL_INDEPENDENT_DISTRIBUTORSHIP,
    getAllIndependentDistributorshipWorker,
  );
};

const getIndependentDistributorNearMeWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    getIndependentDistributorNearMeSuccess,
    getIndependentDistributorNearMeFailure,
    GetIndependentDistributorNearMeApi,
    payload,
  );
};
export const getIndependentDistributorNearMeWatcher = function* () {
  yield takeEvery(
    GET_INDEPENDENT_DISTRIBUTOR_NEAR_ME,
    getIndependentDistributorNearMeWorker,
  );
};

const getUserByIdWorker = function* ({ body, payload }) {
  yield call(
    requestFunction,
    getUserByIdSuccess,
    getUserByIdFailure,
    GetUserByIdApi,
    body,
    payload,
  );
};
export const getUserByIdWatcher = function* () {
  yield takeEvery(GET_USER_BY_ID, getUserByIdWorker);
};

const getPendingApplicationWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    getPendingApplicationSuccess,
    getPendingApplicationFailure,
    GetPendingApplicationApi,
    payload,
  );
};
export const getPendingApplicationWatcher = function* () {
  yield takeEvery(GET_PENDING_APPLICATION, getPendingApplicationWorker);
};

const getApprovedApplicationWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    getApprovedApplicationSuccess,
    getApprovedApplicationFailure,
    GetApprovedApplicationApi,
    payload,
  );
};
export const getApprovedApplicationWatcher = function* () {
  yield takeEvery(GET_APPROVED_APPLICATION, getApprovedApplicationWorker);
};

const postAssignedDistributorWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    postAssignedDistributorSuccess,
    postAssignedDistributorFailure,
    PostAssignedDistributorApi,
    payload,
  );
};
export const postAssignedDistributorWatcher = function* () {
  yield takeEvery(POST_ASSIGNED_DISTRIBUTOR, postAssignedDistributorWorker);
};

const getUserProfileDetailsWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    getUserProfileDetailsSuccess,
    getUserProfileDetailsFailure,
    GetUserProfileDetailsApi,
    payload,
  );
};
export const getUserProfileDetailsWatcher = function* () {
  yield takeEvery(GET_USER_PROFILE_DETAILS, getUserProfileDetailsWorker);
};

const postProfilePictureAvatarWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    postProfilePictureAvatarSuccess,
    postProfilePictureAvatarFailure,
    UpdateProfilePictureApi,
    payload,
  );
};
export const postProfilePictureAvatarWatcher = function* () {
  yield takeEvery(POST_PROFILE_PICTURE_AVATAR, postProfilePictureAvatarWorker);
};

const getAllRolesWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    getAllRolesSuccess,
    getAllRolesFailure,
    GetAllRolesApi,
    payload,
  );
};
export const getAllRolesWatcher = function* () {
  yield takeEvery(GET_ALL_ROLES, getAllRolesWorker);
};

const postCreateEmployeeWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    postCreateEmployeeSuccess,
    postCreateEmployeeFailure,
    PostCreateEmployeeApi,
    payload,
  );
};
export const postCreateEmployeeWatcher = function* () {
  yield takeEvery(CREATE_EMPLOYEE, postCreateEmployeeWorker);
};

const postCreateDistributorWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    postCreateDistributorCustomerSuccess,
    postCreateDistributorCustomerFailure,
    PostCreateDistributorApi,
    payload,
  );
};
export const postCreateDistributorWatcher = function* () {
  yield takeEvery(CREATE_DISTRIBUTOR_CUSTOMER, postCreateDistributorWorker);
};

const postCreateRetailerWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    postCreateRetailerCustomerSuccess,
    postCreateRetailerCustomerFailure,
    PostCreateRetailerApi,
    payload,
  );
};
export const postCreateRetailerWatcher = function* () {
  yield takeEvery(CREATE_RETAILER_CUSTOMER, postCreateRetailerWorker);
};

const postCreateExclusiveWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    postCreateExclusiveCustomerSuccess,
    postCreateExclusiveCustomerFailure,
    PostCreateExclusiveApi,
    payload,
  );
};
export const postCreateExclusiveWatcher = function* () {
  yield takeEvery(CREATE_EXCLUSIVE_CUSTOMER, postCreateExclusiveWorker);
};

const updateEmployeeDetailsRequest = function* ({ payload }) {
  yield call(
    requestFunction,
    updateEmployeeDetailsSuccess,
    updateEmployeeDetailsFailure,
    UpdateEmployeeDetailsApi,
    payload,
  );
};
export const updateEmployeeDetailsWatcher = function* () {
  yield takeEvery(UPDATE_EMPLOYEE_DETAILS, updateEmployeeDetailsRequest);
};

const getEmployeeUnpaginatedRequest = function* ({ payload }) {
  yield call(
    requestFunction,
    getEmployeeUnpaginatedDataSuccess,
    getEmployeeUnpaginatedDataFailure,
    GetEmployeeDataUnpaginatedApi,
    payload,
  );
};
export const getEmployeeUnpaginatedWatcher = function* () {
  yield takeEvery(GET_EMPLOYEE_DATA, getEmployeeUnpaginatedRequest);
};

const updateRoleDetailsRequest = function* ({ payload }) {
  yield call(
    requestFunction,
    updateRoleDetailsSuccess,
    updateRoleDetailsFailure,
    UpdateRoleDetailsApi,
    payload,
  );
};
export const updateRoleDetailsWatcher = function* () {
  yield takeEvery(UPDATE_ROLE, updateRoleDetailsRequest);
};

const getGooglePlacesWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    getGooglePlacesSuccess,
    getGooglePlacesFailure,
    GetGooglePlacesApi,
    payload,
  );
};
export const getGooglePlacesWatcher = function* () {
  yield takeEvery(GET_GOOGLE_PLACES, getGooglePlacesWorker);
};

const googleSignInWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    googleSignInSuccess,
    googleSignInFailure,
    GoogleSignInApi,
    payload,
  );
};
export const googleSignInWatcher = function* () {
  yield takeEvery(GOOGLE_SIGN_IN, googleSignInWorker);
};

const googleSignUpWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    googleSignUpSuccess,
    googleSignUpFailure,
    GoogleSignInApi,
    payload,
  );
};
export const googleSignUpWatcher = function* () {
  yield takeEvery(GOOGLE_SIGN_UP, googleSignUpWorker);
};

const updateUserStatusWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    updateUserStatusSuccess,
    updateUserStatusFailure,
    UpdateUserStatusApi,
    payload,
  );
};
export const updateUserStatusWatcher = function* () {
  yield takeEvery(UPDATE_USER_STATUS, updateUserStatusWorker);
};

const updateUserDataWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    updateUserDataSuccess,
    updateUserDataFailure,
    UpdateUserDataApi,
    payload,
  );
};
export const updateUserDataWatcher = function* () {
  yield takeEvery(UPDATE_USER_DATA, updateUserDataWorker);
};

const updateBusinessDataWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    updateBusinessDataSuccess,
    updateBusinessDataFailure,
    UpdateBusinessDataApi,
    payload,
  );
};
export const updateBusinessDataWatcher = function* () {
  yield takeEvery(UPDATE_BUSINESS_DATA, updateBusinessDataWorker);
};

const deleteUserAccountWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    deleteUserAccountSuccess,
    deleteUserAccountFailure,
    DeleteUserAccountApi,
    payload,
  );
};
export const deleteUserAccountWatcher = function* () {
  yield takeEvery(DELETE_USER_ACCOUNT, deleteUserAccountWorker);
};

const getRejectedApplicationWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    getRejectedApplicationSuccess,
    getRejectedApplicationFailure,
    GetRejectedApplicationApi,
    payload,
  );
};
export const getRejectedApplicationWatcher = function* () {
  yield takeEvery(GET_REJECTED_APPLICATION, getRejectedApplicationWorker);
};

const rejectApplicationWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    rejectApplicationSuccess,
    rejectApplicationFailure,
    RejectApplicationApi,
    payload,
  );
};
export const rejectApplicationWatcher = function* () {
  yield takeEvery(REJECT_APPLICATION, rejectApplicationWorker);
};

const searchCustomersWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    searchCustomersSuccess,
    searchCustomersFailure,
    SearchCustomersApi,
    payload,
  );
};
export const searchCustomersWatcher = function* () {
  yield takeEvery(SEARCH_CUSTOMERS, searchCustomersWorker);
};

const searchRolesWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    searchRolesSuccess,
    searchRolesFailure,
    SearchRolesApi,
    payload,
  );
};
export const searchRolesWatcher = function* () {
  yield takeEvery(SEARCH_ROLES, searchRolesWorker);
};

const deleteApplicantDocumentWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    deleteApplicantDocumentSuccess,
    deleteApplicantDocumentFailure,
    DeleteApplicantDocumentApi,
    payload,
  );
};
export const deleteApplicantDocumentWatcher = function* () {
  yield takeEvery(DELETE_APPLICANT_DOCUMENT, deleteApplicantDocumentWorker);
};

const fetchTempOtpForAdminWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    fetchTempOtpForAdminSuccess,
    fetchTempOtpForAdminFailure,
    getTempOtpForAdminApi,
    payload,
  );
};
export const fetchTempOtpForAdminWatcher = function* () {
  yield takeEvery(FETCH_TEMP_OTP_FOR_ADMIN, fetchTempOtpForAdminWorker);
};

// 👉 NEW 2FA WORKERS
const setup2FAWorker = function* () {
  yield call(requestFunction, setup2FASuccess, setup2FAFailure, Setup2FAApi);
};
export const setup2FAWatcher = function* () {
  yield takeEvery(SETUP_2FA, setup2FAWorker);
};

const verifySetup2FAWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    verifySetup2FASuccess,
    verifySetup2FAFailure,
    VerifySetup2FAApi,
    payload,
  );
};
export const verifySetup2FAWatcher = function* () {
  yield takeEvery(VERIFY_SETUP_2FA, verifySetup2FAWorker);
};

const disable2FAWorker = function* () {
  yield call(
    requestFunction,
    disable2FASuccess,
    disable2FAFailure,
    Disable2FAApi,
  );
};
export const disable2FAWatcher = function* () {
  yield takeEvery(DISABLE_2FA, disable2FAWorker);
};

const verify2FALoginWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    verify2FALoginSuccess,
    verify2FALoginFailure,
    Verify2FALoginApi,
    payload,
  );
};
export const verify2FALoginWatcher = function* () {
  yield takeEvery(VERIFY_2FA_LOGIN, verify2FALoginWorker);
};

export default function* authSaga() {
  yield all([
    fork(getSignupWatcher),
    fork(getOtpVerificationWatcher),
    fork(getResendOtpVerificationWatcher),
    fork(getSigninWatcher),
    fork(getForgotPasswordWatcher),
    fork(getNewPasswordWatcher),
    fork(getChangePasswordWatcher),
    fork(getUserTypeWatcher),
    fork(getRelationshipTypeWatcher),
    fork(getNatureOfBusinessWatcher),
    fork(getStateWatcher),
    fork(getLocalGovermentByStateIdWatcher),
    fork(postUserTypeWatcher),
    fork(postBusinessDetailsWatcher),
    fork(postBusinessLocationWatcher),
    fork(postBusinessHistoryWatcher),
    fork(postBusinessContactWatcher),
    fork(postUserDetailsWatcher),
    fork(postBusinessDocumentWatcher),
    fork(getBusinessDocumentWatcher),
    fork(postBusinessAreaWatcher),
    fork(getBusinessAreaWatcher),
    fork(getAllCustomerWatcher),
    fork(getAllSystemAdminWatcher),
    fork(getAllIndependentDistributorshipWatcher),
    fork(getIndependentDistributorNearMeWatcher),
    fork(getUserByIdWatcher),
    fork(getPendingApplicationWatcher),
    fork(getApprovedApplicationWatcher),
    fork(postAssignedDistributorWatcher),
    fork(getUserProfileDetailsWatcher),
    fork(postProfilePictureAvatarWatcher),
    fork(getAllRolesWatcher),
    fork(postCreateEmployeeWatcher),
    fork(postCreateDistributorWatcher),
    fork(postCreateRetailerWatcher),
    fork(postCreateExclusiveWatcher),
    fork(updateEmployeeDetailsWatcher),
    fork(getEmployeeUnpaginatedWatcher),
    fork(updateRoleDetailsWatcher),
    fork(updateBusinessDocumentWatcher),
    fork(updateBusinessAreaWatcher),
    fork(getGooglePlacesWatcher),
    fork(googleSignInWatcher),
    fork(googleSignUpWatcher),
    fork(updateUserStatusWatcher),
    fork(updateUserDataWatcher),
    fork(updateBusinessDataWatcher),
    fork(deleteUserAccountWatcher),
    fork(getRejectedApplicationWatcher),
    fork(rejectApplicationWatcher),
    fork(searchCustomersWatcher),
    fork(searchRolesWatcher),
    fork(deleteApplicantDocumentWatcher),
    fork(fetchTempOtpForAdminWatcher),

    // 👉 NEW 2FA WATCHERS INCLUDED
    fork(setup2FAWatcher),
    fork(verifySetup2FAWatcher),
    fork(disable2FAWatcher),
    fork(verify2FALoginWatcher),
  ]);
}
